import { NgModule } from '@angular/core';
import { RoomManagementComponent } from './room-management.component';
import { Gt2PrimengModule } from '../../modules/gt2-primeng.module';
import { RouterModule } from '@angular/router';
import { EventRoomService } from '../../api/event-room.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AppRoutesName } from '../../const/AppRoutesName';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CreateOrderButtonsComponent } from '../../components/create-order-buttons/create-order-buttons.component';
import { GenericAlertComponent } from '../../components/generic-alert/generic-alert.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CommonModule } from '@angular/common';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { CreateCongressesButtonComponent } from '../../components/create-congresses-button/create-congresses-button.component';
import { MatBadgeModule } from '@angular/material/badge';
import { NumberNotInfinityPipeModule } from '../../modules/number-not-infinity.module';
import { MomentFormatModule } from '../../modules/moment-format.module';
import { NumericDirectiveModule } from '../../modules/numeric.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkTableModule } from '@angular/cdk/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ColorPickerModule } from 'ngx-color-picker';
import { MatDividerModule } from '@angular/material/divider';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ClipboardModule } from 'ngx-clipboard';
import { MatRippleModule } from '@angular/material/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FullcalendarPickerComponent } from '../../components/fullcalendar-picker/fullcalendar-picker.component';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ROOM_MANAGEMENT,
    component: RoomManagementComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ROOM_MANAGEMENT,
    component: RoomManagementComponent,
  },
];

@NgModule({
  declarations: [RoomManagementComponent],
  imports: [
    CreateOrderButtonsComponent,
    MatInputModule,
    GenericAlertComponent,
    MatButtonModule,
    CommonModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    EditorModule,
    NgxPermissionsModule,
    FormsModule,
    Gt2PrimengModule,
    RouterModule.forChild(routes),
    MatIconModule,
    TranslateModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    NgxMaterialTimepickerModule,

    FullcalendarPickerComponent,

    MatBadgeModule,
    NumberNotInfinityPipeModule,
    MomentFormatModule,
    NumericDirectiveModule,
    MatStepperModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule,
    MatListModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    CdkTableModule,
    MatTabsModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatSidenavModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatMenuModule,
    MatSortModule,
    MatToolbarModule,
    MatSlideToggleModule,
    ColorPickerModule,
    MatDividerModule,
    NgxSpinnerModule,
    ClipboardModule,
    MatRippleModule,
    ScrollingModule,
    CreateCongressesButtonComponent,
    CreateOrderButtonsComponent,
  ],
  exports: [RoomManagementComponent],
  providers: [EventRoomService],
})
export class RoomManagementModule {}
